<template>
  <span>
    <el-button
      @click="showSelector"
      type="primary"
      size="mini"
    >
      {{ title }}
    </el-button>
    <el-dialog
      :title="title"
      :visible.sync="isShow"
      :append-to-body="true"
    >
      <el-card>
        <el-button
          v-show="!isAdd"
          type="primary"
          @click="setAdd(true, 0)"
        >
          <i class="el-icon-plus"></i>
          {{ $t('api.product.name') }}
        </el-button>
        <el-table
          class="no-hover"
          :data="products"
          stripe
        >
          <el-table-column
            type="index"
          >
          </el-table-column>
          <el-table-column
            align="center"
            :label="$t('api.branch.name')"
          >
            <template slot-scope="scope">
              <item-link
                base="branch"
                basePath="/merchant/branch"
                baseIDField="bid"
                idField="bid"
                nameField="branch_name"
                :rowData="scope.row"
                :isAllowSearch="false"
                displayType="link"
                type="primary"
                class="list-main"
              >
              </item-link>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            :label="$t('api.product.name')"
          >
            <template slot-scope="scope">
              <item-link
                base="product"
                basePath="/merchant/product"
                :rowData="scope.row"
                :isAllowSearch="false"
                displayType="link"
                type="primary"
                class="list-main"
              >
              </item-link>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            :label="$t('api.action')"
            fixed="right"
            class-name="list-action-btns"
            width="120"
          >
            <template slot-scope="scope">
              <act-btn
                type="primary"
                icon="el-icon-plus"
                @click="setAdd(true, scope.$index+1)"
                :tip="$t('api.default.create', $t('api.product'))"
              >
              </act-btn>
              <act-btn
                type="danger"
                icon="el-icon-delete"
                @click="del(scope.$index)"
                :tip="$t('api.default.delBtn', $t('api.product'))"
              >
              </act-btn>
            </template>
          </el-table-column>
        </el-table>
      </el-card>
    </el-dialog>
    <el-dialog
      :title="title"
      :visible.sync="isAdd"
      :append-to-body="true"
      @close="closeAdd"
    >
      <el-form>
        <el-row :gutter="20">
          <el-col :xs="24">
            <remote-opt
              v-model="bid"
              base="product"
              name="bid"
              :fetchList="fetchBranchList"
              :labelArr="['bid', 'name']"
              :srchFilter="branchFilter"
              keyName="bid"
              valueName="bid"
              :isAutoFetch="false"
              :pageLimit="20"
              sort="-bid"
              clearable
              ref="branchOpt"
            >
            </remote-opt>
          </el-col>
          <el-col :xs="24">
            <remote-opt
              v-model="prdOpts"
              :base="base"
              :name="name"
              :fetchList="fetchProductList"
              :labelArr="['id', 'branch_name', 'name']"
              :baseFilter="getProductFilter(false)"
              :srchFilter="getProductFilter(true)"
              :isAutoFetch="!!bid"
              :disabled="!!!bid"
              :pageLimit="20"
              sort="-id"
              clearable
              multiple
              ref="productOpt"
            >
            </remote-opt>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer">
        <el-button
          type="primary"
          @click="add"
          :disabled="prdOpts.length === 0"
        >
          {{ $t('api.default.create', $t('api.product')) }}
        </el-button>
        <el-button
          @click="setAdd(false)"
        >
          {{ $t('api.cancelBtn') }}
        </el-button>
      </div>
    </el-dialog>
  </span>
</template>

<script>

import { fetchList as fetchBranchList } from '@/api/merchant/branch'
import { fetchList as fetchProductList } from '@/api/merchant/product'
import { branchFilter } from '@/utils/filter'
import { getTransText } from '@/utils/i18n'

export default {
  name: 'product-selector',
  props: {
    value: null,
    base: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    opts: {
      type: Array,
      default: () => []
    },
    optsMap: {
      type: Object,
      default: () => {}
    },
    filterObj: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      bid: null,
      branchFilter: branchFilter,
      isShow: false,
      isAdd: false,
      isDirectAdd: false,
      addIdx: 0,
      prdOpts: []
    }
  },
  computed: {
    products () {
      let res = []
      for (let i = 0; i < this.value.length; ++i) {
        res.push(this.optsMap[this.value[i]])
      }
      return res
    },
    title () {
      return this.getTransText(this.name, 'selector', this.base)
    }
  },
  methods: {
    getTransText,
    fetchBranchList,
    fetchProductList,
    reset () {
      this.bid = null
      this.$refs.branchOpt.reset()
      this.resetProductOpt()
    },
    resetProductOpt () {
      this.prdOpts.splice(0, this.prdOpts.length)
      this.$refs.productOpt.reset()
    },
    showSelector () {
      this.isShow = true
      this.isDirectAdd = false
      if (this.value.length === 0) {
        this.isDirectAdd = true
        this.setAdd(true, 0)
      }
    },
    closeAdd () {
      if (this.isDirectAdd && this.prdOpts.length === 0) {
        this.isShow = false
      }
    },
    getProductFilter (isSearch) {
      let filter = {
        '$and': []
      }
      if (this.bid) {
        filter['$and'].push({
          'bid': this.bid
        })
      }
      if (this.value.length > 0) {
        filter['$and'].push({
          'id': {
            '$nin': this.value
          }
        })
      }
      if (isSearch) {
        filter['$and'].push({
          '$or': [{
            'id': '`int`'
          }, {
            'unhide_pid': '`int`'
          }, {
            'name': '%`value`%'
          }]
        })
      }
      if (this.filterObj) {
        filter['$and'].push(this.filterObj)
      }
      return JSON.stringify(filter)
    },
    setAdd (v, idx) {
      this.isAdd = v
      if (idx !== undefined) {
        this.addIdx = idx
      }
      this.bid = null
    },
    add () {
      let j = 0
      for (let i = 0; i < this.prdOpts.length; ++i) {
        let key = this.prdOpts[i]
        if (this.value.includes(key)) {
          continue
        }
        if (this.$refs.productOpt) {
          let item = this.$refs.productOpt.optsMap[key]
          if (item) {
            let idx = this.addIdx + j
            this.value.splice(idx, 0, key)
            this.opts.push(item)
            this.optsMap[key] = item
            j++
          }
        }
      }
      this.resetProductOpt()
      this.setAdd(false)
    },
    del (idx) {
      let key = this.value[idx]
      this.value.splice(idx, 1)
      this.opts.filter(item => item.id === key)
      delete this.optsMap[key]
    }
  }
}
</script>
